var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaneicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 19,
    viewBox: "0 0 26 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02908 9.66691L2.64429 7.35272L1 8.63162L7.02908 12.7728L12.8755 9.97141V17.2794L15.9204 15.8787L17.6865 7.83992L23.2893 4.30774C24.2028 3.79009 24.9254 3.30289 24.9945 2.35894C25.1407 0.361432 22.3352 0.998849 20.9142 1.56725L7.02908 9.66691Z",
    stroke: "#FFB800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1898 4.79469L9.03896 2.0542L6.90747 2.8459L11.9622 7.04798",
    stroke: "#FFB800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76997 5.64746L8.43018 6.31736",
    stroke: "#FFB800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.36869 4.30762L6.84619 4.97751",
    stroke: "#FFB800"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8762 12.3464L11.2319 13.0163",
    stroke: "#FFB800"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8152 14.4175L11.9626 14.9047",
    stroke: "#FFB800"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.7435,
    cy: 5.98249,
    r: 0.517648,
    fill: "#878B8E"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.6295,
    cy: 5.06892,
    r: 0.517648,
    fill: "#878B8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaneicon);
export default __webpack_public_path__ + "static/media/planeicon.776172d8b9a9d2b761026f74b2ad2b75.svg";
export { ForwardRef as ReactComponent };